{
  "chapel": {
    "u0": -18.1,
    "chordU": 18.2,
    "vc": 21.5,
    "half": 4.4,
    "eaveY": 13.2,
    "ridgeY": 19.7
  },
  "belfry": {
    "u": 11.5,
    "v": 21.5,
    "radius": 0.5,
    "foot": 17.7,
    "eaves": 19.7,
    "tip": 25
  },
  "ranges": [
    {
      "id": "southern-gabled-wing",
      "u": -1.9,
      "v": -19.8,
      "angleDeg": 180,
      "length": 42.6,
      "width": 7.8,
      "eaves": 10.4,
      "ridge": 15.4,
      "floors": 3,
      "bays": 9,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-18, -12, -6, 0, 6, 12, 18],
        "halfWidth": 1.15,
        "v0": 0.85,
        "v1": 3.9,
        "eaves": 14.5,
        "ridge": 16.7,
        "sill": 12.7,
        "top": 13.8
      }
    },
    {
      "id": "nes-wing",
      "u": -20.8,
      "v": -1.15,
      "angleDeg": -90,
      "length": 37.3,
      "width": 5.8,
      "eaves": 9.4,
      "ridge": 14.1,
      "floors": 2,
      "bays": 8,
      "roof": "slate",
      "passage": 0,
      "roofGables": {
        "centres": [-15, -7.5, 0, 7.5, 15],
        "halfWidth": 0.75,
        "v0": 0.85,
        "v1": 2.9,
        "eaves": 12.9,
        "ridge": 14.6,
        "sill": 11.1,
        "top": 12.200000000000001
      }
    },
    {
      "id": "canal-gate-wing",
      "u": 16.4,
      "v": -8.1,
      "angleDeg": -90,
      "length": 31.2,
      "width": 6.2,
      "eaves": 10.6,
      "ridge": 15.2,
      "floors": 3,
      "bays": 6,
      "roof": "slate",
      "passage": 3,
      "roofGables": {
        "centres": [-12, -6, 0, 6, 12],
        "halfWidth": 0.9,
        "v0": 0.85,
        "v1": 3.1,
        "eaves": 14.1,
        "ridge": 15.8,
        "sill": 12.299999999999999,
        "top": 13.4
      },
      "passageU": 5.4
    },
    {
      "id": "chapel-front-house",
      "u": 17.4,
      "v": 12.4,
      "angleDeg": 0,
      "length": 5.1,
      "width": 9.8,
      "eaves": 8.3,
      "ridge": 11.6,
      "floors": 2,
      "bays": 2,
      "roof": "tile",
      "passage": 0
    }
  ],
  "floors": [
    {
      "ring": [
        [-17.85, -15.8],
        [13.2, -15.8],
        [13.2, 17],
        [-17.85, 17]
      ],
      "height": 0.025,
      "garden": false
    },
    {
      "ring": [
        [-15.1, -12.9],
        [10.3, -12.9],
        [10.3, 14.1],
        [-15.1, 14.1]
      ],
      "height": 0.04,
      "garden": true
    }
  ],
  "walls": [],
  "note": "The 1538 painting and 1544 woodcut guide a large open court, northern cross-plot chapel, unequal Nes and southern gabled wings, a long canal range with a private gate and a lower body beside the chapel front. These are individually recorded institutional bodies rather than a scaled generic garth or generated domestic fill. The Rijksmuseum 1760 view is explicitly derived from Anthonisz 1544, not an independent medieval survey. All lengths, widths, elevations, roof gable counts, openings, belfry, gate position, soil boundaries, hidden connections and precinct edge are fitted estimates. The exact room functions and complete property bounds are unresolved. The southern reservation stops short of the Grimburgwal and preserves the canal street and neighbouring house strip. This Nes convent is separate from the Heiligeweg Clarissen; no later Kuiperstraat or Gebed Zonder End is backdated."
}
